
import axios from "axios";
import { baseUrl } from "../apiUrl";
import { buildQueryString, QueryParam } from "../queryUtils";
import { Communities, Community } from "./types";



export const getCommunities = async (query: QueryParam): Promise<Communities> => {
     try {
          const response = await axios({
               url: `${baseUrl}/clo-dvs/division/communities?${buildQueryString(query)}`,
               method: 'GET',
          });
          return response.data;
     } catch (error) {
          throw new Error(`Failed to fetch Communities: ${error}`);
     }
};

// Update a community by ID
export const updateCommunity = async (updateCommunity: Partial<Community>): Promise<Community> => {
     try {
          const response = await axios({
               url: `${baseUrl}/clo-dvs/division/communities`,
               method: 'PATCH',
               data: updateCommunity,
          });
          return response.data;
     } catch (error) {
          throw new Error(`Failed to update Community: ${error}`);
     }
};